import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SellerLayout from './components/SellerLayout';
import OfferPageComponent from './components/OffersComponents/OfferPageComponent';

const OfferPage = () => {
    return (
        <div className="request-page" style={styles.pageContainer}>
            <SellerLayout>
                <div style={styles.sectionWrapper}>
                    <div style={styles.headerRow}>
                    </div>
                </div>
                <OfferPageComponent />
            </SellerLayout>
        </div>
    );
};

export default OfferPage;

const styles = {
    pageContainer: {
        backgroundColor: '#FFF',
        minHeight: '100vh',
    },
    sectionWrapper: {
        marginBottom: '30px',
        marginTop: '20px',
    },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginLeft: '20px',
        marginBottom: '10px',
    },
};
